import React from "react"
import propTypes from "prop-types"

const Description = ({ children }) => {
  return <div className="info-dashboard_description">{children}</div>
}

Description.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Description
